import { Spin, SpinProps } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import "./Loader.scss";

interface LoaderProps extends SpinProps {
  hidden?: boolean;
  fontSize?: number;
  global?: boolean;
}

const Simple: React.FC<LoaderProps> = (props) => {
  const { fontSize = 24, hidden } = props;
  if (hidden) return null;
  return (
    <div className="loader">
      <Spin
        indicator={<LoadingOutlined style={{ fontSize }} spin={false} />}
        {...props}
      />
    </div>
  );
};

export default Simple;
